// extracted by mini-css-extract-plugin
export default {"title":"update_questions_modal-module___title___a2a5d098","warningIcon":"update_questions_modal-module___warningIcon___c74aeec2"};